import { hideLoading, showLoading } from '../../../../../shared/components/modal.js';
import { updateNotificationSettings } from "../../../unit-sensors/views/unitdiagrams/repeaters/units.api.js"

export const openNotificationsForm = (unit) => {

    const { notificationSettings = {} } = unit;

    document.body.style.cursor = 'wait';

    const notificationsmodal = document.getElementById('notificationsmodal');
    const closeModal = document.getElementById("closenotificationsmodal");
    const notificationsform = document.getElementById('notificationsform');

    closeModal.onclick = (e) => {
        e.stopImmediatePropagation();
        notificationsmodal.style.display = "none";
    };

    setCheckboxValue('nfPressureCheck', notificationSettings.pressure);
    setCheckboxValue('nfTemperatureCheck', notificationSettings.temperature);
    setCheckboxValue('nfVoltageCheck', notificationSettings.voltage);
    setCheckboxValue('nfNoSignalCheck', notificationSettings.truckInactivity);
    setCheckboxValue('nfUnlinkedCheck', notificationSettings.linkedUnlinked);
    setInputValue('nfEmailAddress1', notificationSettings.email1);
    setInputValue('nfEmailAddress2', notificationSettings.email2);
    setInputValue('nfEmailAddress3', notificationSettings.email3);

    notificationsform.onsubmit = function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        submitNotificationsForm(unit);
    };

    document.body.style.cursor = 'default';
    document.getElementById("notificationsmodal").style.display = 'block';
}

function setCheckboxValue(elementId, value) {
    document.getElementById(elementId).checked = !!value;
}

function setInputValue(elementId, value) {
    document.getElementById(elementId).value = value || "";
}

async function submitNotificationsForm(unit) {

    document.getElementById("loadingBoxText").innerText = "Updating notification data... ";
    showLoading();

    if (!unit.notificationSettings) {
        unit.notificationSettings = {};
    }

    unit.notificationSettings.pressure = document.getElementById('nfPressureCheck').checked;
    unit.notificationSettings.temperature = document.getElementById('nfTemperatureCheck').checked;
    unit.notificationSettings.voltage = document.getElementById('nfVoltageCheck').checked;
    unit.notificationSettings.truckInactivity = document.getElementById('nfNoSignalCheck').checked;
    unit.notificationSettings.linkedUnlinked = document.getElementById('nfUnlinkedCheck').checked;
    unit.notificationSettings.email1 = document.getElementById('nfEmailAddress1')?.value.trim() || "user@example.com";
    unit.notificationSettings.email2 = document.getElementById('nfEmailAddress2')?.value.trim() || "user@example.com";
    unit.notificationSettings.email3 = document.getElementById('nfEmailAddress3')?.value.trim() || "user@example.com";
    unit.notificationSettings.minutesBetweenNotifications = 60;

    await updateNotificationSettings(unit);
    document.getElementById("notificationsmodal").style.display = 'none';
    hideLoading();
    return false;
}

